import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    updateProfileV2: gql`
        mutation UpdateProfileV2($handle: String, $name: String, $image: ImageInput, $whiteLabelImage: ImageInput, $brandColor: String, $brandLink: String, $language: String, $defaultPrivacyText: String, $defaultTermsText: String, $defaultTermsAndConditionsConsentText: String, $defaultPrivacyPolicyConsentText: String, $boostWords: String) {
            updateProfileV2(updateProfileInput: { handle: $handle, name: $name, image: $image, whiteLabelImage: $whiteLabelImage, brandColor: $brandColor, brandLink: $brandLink, language: $language, defaultPrivacyText: $defaultPrivacyText, defaultTermsText: $defaultTermsText, defaultTermsAndConditionsConsentText: $defaultTermsAndConditionsConsentText, defaultPrivacyPolicyConsentText: $defaultPrivacyPolicyConsentText, boostWords: $boostWords }) {
                ...ProfileFragment
            }
        }

        ${fragments.profile}
        ${fragments.image}
    `,
};
